export default __webpack_public_path__ + "static/media/Service-2.052eeae4.jpg";